export default "__VITE_PUBLIC_ASSET__a8705b23__"